import ContatoreComponent from "./ContatoreComponent"

export default function handlePage9(data) {
    const amont =  (isNaN(parseInt(data["D84"]))) ? data["C82"] : data["D84"] 
    return [<ContatoreComponent red={true} amount={amont}/>]
}